import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { HaloModalSize } from '../halo-modal/halo-modal-interface';
import { HaloModalService } from '../halo-modal/halo-modal.service';
import { CroppedImage } from './image-cropper.model';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit, AfterViewInit {
  private isLoadError = false;
  private lastCroppedImage: ImageCroppedEvent;

  @Input() title: string;
  @Input() imageUrl: string;
  @Input() imageFile: File;  
  @Input() aspectRatio = 1;
  @Input() resizeToWidth = 0;
  @Input() resizeToHeight = 0;
  @Input() cropperMinWidth = 0;
  @Input() cropperMinHeight = 0;
  @Input() cropperMaxWidth = 0;
  @Input() cropperMaxHeight = 0;
  @Input() maintainAspectRatio = false;
  @Input() onlyScaleDown = false;
  @Input() roundCropper = false;
  @Output() croppedImage = new EventEmitter<CroppedImage | null>();
  @ViewChild('imageEditorTemplate') imageEditorTemplate: TemplateRef<any>;
  @ViewChild('editorActionTemplate') editorActionTemplate: TemplateRef<any>;
  constructor(private modal: HaloModalService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.modal.addForeground({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.title,
      bodyTemplate: this.imageEditorTemplate,
      footerTemplate: this.editorActionTemplate,
      onDismiss: () => this.onDismiss()
    });
  }

  private onDismiss() {
    this.croppedImage.emit(null);
  }

  private imageCropped(event: ImageCroppedEvent) {
    this.lastCroppedImage = event;
  }

  private imageLoaded(image: LoadedImage) {
    if(this.cropperMinWidth === 0 && this.resizeToWidth > 0) {
      this.aspectRatio = this.resizeToWidth/this.resizeToHeight;
      this.cropperMinWidth = this.resizeToWidth;
      this.cropperMinHeight = this.resizeToHeight;
      if(image.original.size.width > image.transformed.size.width) {
        let ratio = this.resizeToWidth / image.original.size.width;
        this.cropperMinWidth = image.transformed.size.width - (image.transformed.size.width * ratio);
        this.cropperMinHeight = image.transformed.size.height - (image.transformed.size.height * ratio);
      }
    }
  }

  private cropperReady(dimension: any) {
  }

  private loadImageFailed() {
    this.isLoadError = true;
  }

  private onCroppedImage() {
    if(this.lastCroppedImage) {
      this.croppedImage.emit({
        base64: this.lastCroppedImage.base64,
        width: this.lastCroppedImage.width,
        height: this.lastCroppedImage.height,
        cropperPosition: this.lastCroppedImage.cropperPosition
      });
    } else if(this.isLoadError) {
      this.croppedImage.emit(null);
    }
    this.modal.close();
  }
}
